<script setup lang="ts">
  import type { CompiledFieldNode, FieldValue } from '@record-fill';

  const props = defineProps<{ node: CompiledFieldNode; disabled: boolean; readOnly?: boolean; inputClass?: string }>();
  const emit = defineEmits<{ (e: 'update', value: FieldValue): void }>();

  const control = props.node.control.kind === 'textarea' ? props.node.control : null;

  function onInput(event: Event): void {
    emit('update', (event.target as HTMLTextAreaElement).value);
  }
</script>

<template>
  <textarea
    rows="7"
    :class="[
      inputClass,
      readOnly ? 'cursor-default resize-none' : 'resize-y',
      'block min-h-[122px] w-full min-w-0 text-[11px] leading-4 [font-family:var(--font-base)] placeholder:text-[10px] placeholder:opacity-60 disabled:cursor-not-allowed disabled:bg-[var(--color-gray-09)] disabled:opacity-60',
    ]"
    :value="typeof node.value === 'string' ? node.value : ''"
    :placeholder="control?.placeholder"
    :maxlength="control?.maxLength"
    :aria-label="node.label"
    :disabled="disabled"
    :readonly="readOnly"
    :tabindex="readOnly ? -1 : undefined"
    :data-field-id="node.id"
    @input="onInput"
  />
</template>
